import 'react-phone-number-input/style.css';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';

import { CountrySelectSearch } from './CountrySelectSearch';
import * as styled from './styles';

const MAX_E164_DIGITS = 15;

type Props = {
  name: string;
  label?: string;
  placeholder?: string;
};

export const PhoneField = ({ name, label, placeholder }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = errors[name]?.message as string | undefined;

  return (
    <styled.Field>
      {label && <styled.Label>{label}</styled.Label>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const value = field.value as string | undefined;
          const showHint = !error && !!value && !isValidPhoneNumber(value);

          return (
            <>
              <styled.PhoneInputWrap $hasError={!!error}>
                <PhoneInput
                  international
                  defaultCountry="US"
                  countrySelectComponent={CountrySelectSearch}
                  value={value}
                  onChange={(next) => {
                    if (next && next.replace(/\D/g, '').length > MAX_E164_DIGITS)
                      return;
                    field.onChange(next);
                  }}
                  onBlur={field.onBlur}
                  placeholder={placeholder}
                />
              </styled.PhoneInputWrap>
              {showHint && (
                <styled.Hint>
                  That doesn&apos;t look like a valid number — you can leave it
                  blank.
                </styled.Hint>
              )}
            </>
          );
        }}
      />
      {error && <styled.ErrorText>{error}</styled.ErrorText>}
    </styled.Field>
  );
};
